export default class CAHA1230RequestModel {
    reservedAmount:string
    accumulatedBalance:string
    operationPeriod:string
    investmentYield: string
}
